import styled from "@emotion/styled";
import { Box, Button, Grid, Stack, Typography, useTheme } from "@mui/material";
import AppBarCustom from "../../component/AppBar";
import TextFieldCustom from "../../component/textFieldCustom";
import React from "react";

import Api from "../../api/RestApi.json";
import axios from "axios";
import { useLocation, useNavigate } from "react-router-dom";
import { ErrorRounded, SendRounded } from "@mui/icons-material";

const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  padding: theme.spacing(0, 1),

  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
}));
export default function PenggunaForm(params) {
  const theme = useTheme();
  const goTo = useNavigate();
  const { state } = useLocation();
  const { data } = state;

  const [logUser, setLogUser] = React.useState(null);

  const [id, setId] = React.useState(data.id || "");
  const [name, setNama] = React.useState(data.name || "");
  const [username, setUsername] = React.useState(data.username || "");
  const [password, setPassword] = React.useState("");

  const storePost = async (event) => {
    event.preventDefault();
    const data = {
      id,
      name,
      username,
      password,
    };

    try {
      var response = "";
      if (data.id == "") {
        response = await axios.post(Api.pengguna, data);
      } else if (data.id !== "") {
        response = await axios.put(Api.pengguna + "/" + data.id, data);
      }
      // setValidation(data.nama + ' Berhasil Ditambahkan!');
      // console.log(response.data);
      goTo("/pengguna");
      goTo(0);
    } catch (error) {
      setLogUser(error.response.data);
    }
    // console.log(data);
  };

  return (
    <Box
      sx={{
        display: "flex",
        minHeight: "100vh",
        padding: 0,
        bgcolor: "#E1E1E1",
      }}
    >
      <AppBarCustom selected="Pengguna" />
      {/* <Toolbar sx={{ padding: 10 }} /> */}

      <Box component="main" sx={{ flexGrow: 1, p: 3 }}>
        <DrawerHeader theme={theme} />
        <Stack
          direction={"row"}
          justifyContent={"space-between"}
          alignItems={"center"}
        >
          <Typography
            variant="h4"
            sx={{ fontWeight: "bold", marginBottom: 2 }}
            align="left"
          >
            Form Pengguna {data.nama ? " (" + data.nama + ")" : ""}
          </Typography>
          <Button
            variant="contained"
            color="error"
            onClick={(e) => goTo("/pengguna")}
          >
            Kembali
          </Button>
        </Stack>
        <Box padding={2} bgcolor={"white"} borderRadius={4}>
          <form onSubmit={storePost}>
            <Grid container spacing={4}>
              <Grid size={{ xs: 12, md: 12 }}>
                <TextFieldCustom
                  title="Nama Lengkap"
                  name="nama"
                  id="nama"
                  value={name}
                  onChange={(e) => setNama(e.target.value)}
                  type="text"
                  label="Nama"
                  required={true}
                />
              </Grid>

              <Grid size={{ xs: 12, md: 12 }}>
                <TextFieldCustom
                  title="Username "
                  name="username"
                  id="username"
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                  type="text"
                  label="Username (Minimal: 4 Karakter)"
                  required={true}
                />
                {logUser?.data.username && (
                  <Typography
                    color="error.main"
                    sx={{ display: "flex", alignItems: "center" }}
                  >
                    <ErrorRounded sx={{ mr: 1 }} />
                    {logUser.data.username}
                  </Typography>
                )}
              </Grid>

              <Grid size={{ xs: 12, md: 12 }}>
                <TextFieldCustom
                  title="Password "
                  name="password"
                  id="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  type="password"
                  label="Password (Minimal: 8 Karakter)"
                  required={true}
                />
                {logUser?.data.password && (
                  <Typography
                    color="error.main"
                    sx={{ display: "flex", alignItems: "center" }}
                  >
                    <ErrorRounded sx={{ mr: 1 }} />
                    {logUser.data.password}
                  </Typography>
                )}
              </Grid>

              <Grid size={{ xs: 12, md: 12 }}>
                <Box justifySelf={"center"}>
                  <Button
                    type="submit"
                    variant="contained"
                    color="success"
                    size="large"
                    startIcon={<SendRounded/>}
                  >
                    Kirim
                  </Button>
                </Box>
              </Grid>
            </Grid>
          </form>
        </Box>
      </Box>
    </Box>
  );
}
